import { Col, Dropdown, Form, Modal, Row, Space, Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table/interface';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { IPieceLevel, ITrackingHistory, ITrackingHistoryState } from '../../model/TrackingHistoryModal';
import { useTrackingHistoryStore } from '../../stores/TrackingHistoryStore';
import { DD_MM_YYYY_H_MM, FOD, isNotEmptyObject } from '../../utils/app-common';
import { convertDateFromMillis } from '../../utils/luxon';
import LoadingComponent from '../CommonComponent/LoadingComponent';
import LoadingModalComponent from '../CommonComponent/LoadingModalComponent';
import TableComponent from '../CommonComponent/TableComponent';
import { IOperation } from '../../model/OperationModel';
import BackButtonComponent from '../CommonComponent/BackButtonComponent';
import { MenuList } from './MenuListComponent';
import { Link, useParams } from 'react-router-dom';

type ITrackingHistoryComponent = {
    isOpen: boolean,
    closeModal: () => void,
    data?: string,
    children?: JSX.Element
}

const IndividualPieceLevelComponent = ({ isOpen, onCancel, onRefreshHandler }: { isOpen: boolean, onCancel: (value: boolean) => void, onRefreshHandler: () => void }) => {
    const pieceTrackingDetail = useTrackingHistoryStore(state => state?.pieceTrackingDetail);
    const { promiseInProgress: pieceLevelProgress } = usePromiseTracker({ area: 'individual-piece-level-area' });

    const pieceLevelColumn: ColumnsType<IPieceLevel[]> = useMemo(() => [
        {
            title: 'piece BarCode',
            dataIndex: 'pieceBarCode',
            key: 'pieceBarCode',
            width: 80,
            fixed: 'left',
        },
        {
            title: 'station Name',
            dataIndex: 'stationName',
            key: 'stationName',
            width: 80,
            fixed: 'left',
        },
        {
            title: 'event Name',
            dataIndex: 'eventName',
            key: 'eventName',
            width: 80,
        },
        {
            title: 'exception Reason Name',
            dataIndex: 'exceptionReasonName',
            key: 'exceptionReasonName',
            width: 80,
        },
        {
            title: 'Scanned By',
            dataIndex: 'scanBy',
            key: 'scanBy',
            width: 80,
        },
        {
            title: 'scan Date',
            dataIndex: 'scanDate',
            key: 'scanDate',
            width: 80,
            render: (scanDate) => convertDateFromMillis(scanDate, DD_MM_YYYY_H_MM)
        }, {
            title: 'last Event Date',
            dataIndex: 'lastEventDate',
            key: 'lastEventDate',
            width: 80,
            render: (scanDate) => convertDateFromMillis(scanDate, DD_MM_YYYY_H_MM)
        },
        {
            title: 'comment',
            dataIndex: 'comment',
            key: 'comment',
            width: 150,
        },
    ], [])

    return (
        <Modal open={isOpen} centered onCancel={() => onCancel(false)} title='Piece Level Tracking' width={1000} okButtonProps={{ style: { display: 'none' } }}>
            <TableComponent
                scroll={{ x: 0, y: 0 }}
                columns={pieceLevelColumn}
                isLoading={pieceLevelProgress}
                data={pieceTrackingDetail}
                isRefresh={false} />
        </Modal>
    )
}
const PieceLevelComponent = ({ isOpen, onCancel, onRefreshHandler }: { isOpen: boolean, onCancel: (value: boolean) => void, onRefreshHandler: () => void }) => {
    const pieceLevelTrackingDetail = useTrackingHistoryStore(state => state?.pieceLevelTrackingDetail);
    const { promiseInProgress: pieceLevelProgress } = usePromiseTracker({ area: 'piece-level-area' });
    const GetPieceLevelTrackingDetailAction = useTrackingHistoryStore((state: ITrackingHistoryState) => state?.GetPieceLevelTrackingDetailAction);
    const [isPieceLevelModal, setIsPieceLevelModal] = useState(false);

    const getDetails = useCallback((value: string) => {
        trackPromise(GetPieceLevelTrackingDetailAction(value), 'individual-piece-level-area');
    }, [GetPieceLevelTrackingDetailAction])

    const onPieceBarCodeHandler = useCallback((value: string) => {
        getDetails(value)
        setIsPieceLevelModal(true)
    }, [getDetails])

    const pieceLevelColumn: ColumnsType<IPieceLevel[]> = useMemo(() => [
        {
            title: 'piece BarCode',
            dataIndex: 'pieceBarCode',
            key: 'pieceBarCode',
            width: 60,
            fixed: 'left',
            render: (pieceBarCode) => <Typography.Text strong type={'secondary'} underline onClick={() => onPieceBarCodeHandler(pieceBarCode)}>
                {pieceBarCode}</Typography.Text>
        },
        {
            title: 'station Name',
            dataIndex: 'stationName',
            key: 'stationName',
            width: 40,
            fixed: 'left',
        },
        {
            title: 'event Name',
            dataIndex: 'eventName',
            key: 'eventName',
            width: 80,
        },
        {
            title: 'exception Reason Name',
            dataIndex: 'exceptionReasonName',
            key: 'exceptionReasonName',
            width: 80,
        },
        {
            title: 'Scanned By',
            dataIndex: 'scanBy',
            key: 'scanBy',
            width: 80,
        },
        {
            title: 'scan Date',
            dataIndex: 'scanDate',
            key: 'scanDate',
            width: 80,
            render: (scanDate) => convertDateFromMillis(scanDate, DD_MM_YYYY_H_MM)
        },
        {
            title: 'comment',
            dataIndex: 'comment',
            key: 'comment',
            width: 150,
        },
    ], [onPieceBarCodeHandler])

    const onRefresh = () => {
        // getDetails(pieceLevelTrackingDetail?.at(0)?.pieceBarCode!)
    }
    return (
        <Modal open={isOpen} centered onCancel={() => onCancel(false)} title='Piece Level Tracking' width={1000} okButtonProps={{ style: { display: 'none' } }}>
            <TableComponent
                scroll={{ x: 0, y: 0 }}
                columns={pieceLevelColumn}
                isLoading={pieceLevelProgress}
                data={pieceLevelTrackingDetail}
                onRefreshHandle={onRefreshHandler} />
            {isPieceLevelModal ? <IndividualPieceLevelComponent isOpen={isPieceLevelModal} onCancel={() => setIsPieceLevelModal(false)} onRefreshHandler={onRefresh} /> : null}
        </Modal>
    )
}
export const LeftComponent = () => {
    const { getFieldValue } = Form.useFormInstance();
    const [isModal, setIsModal] = useState(false);
    const GetPieceLevelTrackingDetailByWayBillAction = useTrackingHistoryStore((state: ITrackingHistoryState) => state?.GetPieceLevelTrackingDetailByWayBillAction);

    const getDetail = (data: string) => {
        trackPromise(GetPieceLevelTrackingDetailByWayBillAction(data), 'piece-level-area');
    }
    const onWaybillHandler = (data: string) => {
        getDetail(data);
        setIsModal(true);
    };

    const onRefreshHandler = () => {
        getDetail(getFieldValue("waybillNo"))
    }
    return (
        <>
            <Col xxl={8} xl={8} lg={8} md={6}>
                <Row gutter={2} justify={'start'} align={'top'} >
                    <Col xxl={20} xl={20} lg={24}>
                        <Form.Item name={'waybillNo'} label='Waybill No' labelAlign='left' labelCol={{ span: 6, lg: 7, xxl: 7 }} style={{ marginBottom: 1 }}>
                            <Typography.Text strong>{getFieldValue("waybillNo")}</Typography.Text>
                        </Form.Item>
                    </Col>
                    <Col xxl={20} xl={20} lg={24}>
                        <Form.Item name={'bookingDatetime'} label='Waybill Date' labelAlign='left' labelCol={{ span: 6, lg: 7 }} style={{ marginBottom: 1 }}>
                            {/* <Input disabled /> */}
                            <Typography.Text strong>{convertDateFromMillis(getFieldValue("bookingDatetime"), DD_MM_YYYY_H_MM)}</Typography.Text>
                        </Form.Item>
                    </Col>
                    <Col xxl={20} xl={20} lg={24}>
                        <Form.Item name={'pickupDate'} label='Pickup Date' labelAlign='left' labelCol={{ span: 6, lg: 7 }} style={{ marginBottom: 1 }}>
                            {/* <Input disabled /> */}
                            <Typography.Text strong>{convertDateFromMillis(getFieldValue("pickupDate"), DD_MM_YYYY_H_MM)}</Typography.Text>

                        </Form.Item>
                    </Col>
                    <Col xxl={20} xl={20} lg={24}>
                        <Form.Item name={'shipperCity'} label='From' labelAlign='left' labelCol={{ span: 6, lg: 7 }} style={{ marginBottom: 1 }}>
                            {/* <Input disabled /> */}
                            <Typography.Text strong>{(getFieldValue("shipperCity"))}</Typography.Text>
                        </Form.Item>
                    </Col>
                    <Col xxl={20} xl={20} lg={24}>
                        <Form.Item name={'consigneeCity'} label='To' labelAlign='left' labelCol={{ span: 6, lg: 7 }} style={{ marginBottom: 1 }}>
                            {/* <Input disabled /> */}
                            <Typography.Text strong>{(getFieldValue("consigneeCity"))}</Typography.Text>
                        </Form.Item>
                    </Col>
                    <Col xxl={20} xl={20} lg={24}>
                        <Form.Item name={''} label='Shipper ODA City' labelAlign='left' labelCol={{ span: 6, lg: 7 }} style={{ marginBottom: 1 }}>
                            {/* <Input disabled /> */}
                            <Typography.Text strong>{(getFieldValue("shipperOdaCity"))}</Typography.Text>

                        </Form.Item>
                    </Col>
                    <Col xxl={20} xl={20} lg={24}>
                        <Form.Item name={'pickupPieceCount'} label='No of Pkg' labelAlign='left' labelCol={{ span: 6, lg: 7 }} style={{ marginBottom: 1 }}>
                            {/* <Input disabled /> */}
                            <Typography.Text strong type={'secondary'} underline onClick={() => onWaybillHandler(getFieldValue("waybillNo"))}>
                                {(getFieldValue("pickupPieceCount"))}</Typography.Text>
                        </Form.Item>
                    </Col>
                    <Col xxl={20} xl={20} lg={24}>
                        <Form.Item name={'pickupWeight'} label='Weight' labelAlign='left' labelCol={{ span: 6, lg: 7 }} style={{ marginBottom: 1 }}>
                            {/* <Input disabled /> */}
                            <Typography.Text strong>{(getFieldValue("pickupWeight"))}</Typography.Text>

                        </Form.Item>
                    </Col>
                    <Col xxl={20} xl={20} lg={24}>
                        <Form.Item name={'productName'} label='Product' labelAlign='left' labelCol={{ span: 6, lg: 7 }} style={{ marginBottom: 1 }}>
                            {/* <Input disabled /> */}
                            <Typography.Text strong>{(getFieldValue("productName"))}</Typography.Text>
                        </Form.Item>
                    </Col>
                    <Col xxl={20} xl={20} lg={24}>
                        <Form.Item name={'subProduct'} label='Sub-Product' labelAlign='left' labelCol={{ span: 6, lg: 7 }} style={{ marginBottom: 1 }}>
                            {/* <Input disabled /> */}
                            <Typography.Text strong>{(getFieldValue("subProduct"))}</Typography.Text>
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
            {isModal ? <PieceLevelComponent isOpen={isModal} onCancel={setIsModal} onRefreshHandler={onRefreshHandler} /> : null}
        </>
    )
}
export const MiddleComponent = () => {
    const { getFieldValue } = Form.useFormInstance();

    let fieldLabel = "Pay Mode", fieldValue = getFieldValue("billType");
    if (getFieldValue("billType") === FOD) {
        fieldLabel = fieldLabel + " / FOD Amt";
        fieldValue = fieldValue + ` / ${getFieldValue("fodAmount") ?? ""}`;
    }

    return (
        <Col xxl={8} xl={8} lg={8}>
            <Row gutter={2} justify={'start'} align={'top'}>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={'customerName'} label='Customer Name' labelAlign='left' labelCol={{ span: 6, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(getFieldValue("customerName"))}</Typography.Text>

                    </Form.Item>
                </Col>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={'customerAccount'} label='Customer Acc No' labelAlign='left' labelCol={{ span: 6, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(getFieldValue("customerAccount"))}</Typography.Text>

                    </Form.Item>
                </Col>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={'consigneeMobileNo'} label={'Customer Contact No'} labelAlign='left' labelCol={{ span: 7, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(getFieldValue("consigneeMobileNo"))}</Typography.Text>

                    </Form.Item>
                </Col>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={'consigneeName'} label='Consignee Name' labelAlign='left' labelCol={{ span: 7, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(getFieldValue("consigneeName"))}</Typography.Text>

                    </Form.Item>
                </Col>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={''} label='Consignee ODA City' labelAlign='left' labelCol={{ span: 6, lg: 9, xxl: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(getFieldValue("consigneeOdaCity"))}</Typography.Text>

                    </Form.Item>
                </Col>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={'consingeeAddress'} label='Delivery Address' labelAlign='left' labelCol={{ span: 6, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(getFieldValue("consingeeAddress"))}</Typography.Text>

                    </Form.Item>
                </Col>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={'consigneeMobileNo'} label={`C'nee Contact No`} labelAlign='left' labelCol={{ span: 6, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(getFieldValue("consigneeMobileNo"))} / {(getFieldValue("consigneeAlternateMobileNo") || '-')} </Typography.Text>
                    </Form.Item>
                </Col>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={'podFileType'} label='POD Type' labelAlign='left' labelCol={{ span: 6, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(getFieldValue("podFileType"))}</Typography.Text>

                    </Form.Item>
                </Col>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={''} label={`${fieldLabel}`} labelAlign='left' labelCol={{ span: 6, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(fieldValue)}</Typography.Text>

                    </Form.Item>
                </Col>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={''} label='COD Amt' labelAlign='left' labelCol={{ span: 6, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(getFieldValue("codAmount"))}</Typography.Text>

                    </Form.Item>
                </Col>
            </Row>
        </Col>
    )
}
export const RightComponent = () => {
    const { getFieldValue } = Form.useFormInstance();

    return (
        <Col xxl={8} xl={8} lg={8}>
            <Row gutter={2} justify={'start'} align={'top'}>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={''} label='Shipment Status' labelAlign='left' labelCol={{ span: 6, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(getFieldValue("lastEventStatus"))}</Typography.Text>

                    </Form.Item>
                </Col>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={'pickupDriver'} label='Pickup Driver' labelAlign='left' labelCol={{ span: 6, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(getFieldValue("pickupDriver"))}</Typography.Text>

                    </Form.Item>
                </Col>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={'pickupVehicleName'} label='Pickup Vehicle' labelAlign='left' labelCol={{ span: 6, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(getFieldValue("pickupVehicleName"))}</Typography.Text>

                    </Form.Item>
                </Col>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={'deliveryDate'} label='Delivery Date' labelAlign='left' labelCol={{ span: 6, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(convertDateFromMillis(getFieldValue("deliveryDate"), DD_MM_YYYY_H_MM))}</Typography.Text>

                    </Form.Item>
                </Col>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={'deliveryDriver'} label='Delivery Driver' labelAlign='left' labelCol={{ span: 6, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(getFieldValue("deliveryDriver"))}</Typography.Text>

                    </Form.Item>
                </Col>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={'deliveryVehicleName'} label='Delivery Vehicle' labelAlign='left' labelCol={{ span: 6, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(getFieldValue("deliveryVehicleName"))}</Typography.Text>

                    </Form.Item>
                </Col>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={''} label='PFN No.' labelAlign='left' labelCol={{ span: 6, lg: 9 }} style={{ marginBottom: 1 }}>

                        {(getFieldValue("pfnWaybills"))?.map((wayBill) => (
                            <>
                                <Typography.Text strong>
                                    <Link to={`/operation/tracking-history/${wayBill}`}>{`${wayBill}` + "  "}</Link>
                                </Typography.Text>
                            </>
                        ))
                        }
                    </Form.Item>
                </Col>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={'salesmanName'} label='Salesman Name' labelAlign='left' labelCol={{ span: 6, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(getFieldValue("salesmanName"))}</Typography.Text>

                    </Form.Item>
                </Col>
                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={'salesmanEmail'} label='Salesman Email' labelAlign='left' labelCol={{ span: 6, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(getFieldValue("salesmanEmail"))}</Typography.Text>

                    </Form.Item>
                </Col>


                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item
                        name={'croName'}
                        label='Customer Service Name'
                        labelAlign='left'
                        labelCol={{ span: 12, lg: 13 }}
                        wrapperCol={{ span: 12, lg: 11 }}
                        style={{ marginBottom: 1 }}
                    >
                        <Typography.Text strong>{getFieldValue("croName")}</Typography.Text>
                    </Form.Item>
                </Col>

                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item
                        name={'croEmail'}
                        label='Customer Service Email'
                        labelAlign='left'
                        labelCol={{ span: 12, lg: 13 }}
                        wrapperCol={{ span: 12, lg: 11 }}
                        style={{ marginBottom: 1 }}
                    >
                        <Typography.Text strong>{getFieldValue("croEmail")}</Typography.Text>
                    </Form.Item>
                </Col>


                <Col xxl={20} xl={20} lg={24}>
                    <Form.Item name={'industryGroup'} label='Industry Group' labelAlign='left' labelCol={{ span: 6, lg: 9 }} style={{ marginBottom: 1 }}>
                        {/* <Input disabled /> */}
                        <Typography.Text strong>{(getFieldValue("industryGroup"))}</Typography.Text>

                    </Form.Item>
                </Col>
            </Row>
        </Col>
    )
}
export const TrackingHistoryDetailComponent = () => {
    const [form] = Form.useForm();
    const trackingHistoryDetail = useTrackingHistoryStore(state => state?.trackingHistoryDetail);
    const { promiseInProgress: wayBillDetailProgress } = usePromiseTracker({ area: 'tracking-by-waybill-details-area' })

    useEffect(() => {
        if (!isNotEmptyObject(trackingHistoryDetail)) {
            form.resetFields()
        }
        if (isNotEmptyObject(trackingHistoryDetail)) {
            for (const [key, value] of Object.entries(trackingHistoryDetail)) {
                form.setFieldValue(key, value)
            }
        }
    }, [form, trackingHistoryDetail])
    return (
        <LoadingModalComponent isLoading={wayBillDetailProgress}>
            <Form form={form}>
                <Row gutter={1}>
                    <LeftComponent />
                    <MiddleComponent />
                    <RightComponent />
                </Row>
            </Form>
        </LoadingModalComponent>
    )
}
export const TrackingHistoryComponent = ({ isOpen, closeModal, data, children }: ITrackingHistoryComponent) => {
    const { promiseInProgress } = usePromiseTracker({ area: 'tracking-by-way-bill-list-area' })

    const GetTrackingHistoryByWayBillAction = useTrackingHistoryStore((state: ITrackingHistoryState) => state?.GetTrackingHistoryByWayBillAction)
    const GetHistoryDetailByWayBillAction = useTrackingHistoryStore((state: ITrackingHistoryState) => state?.GetHistoryDetailByWayBillAction)
    const trackingHistory: ITrackingHistory[] = useTrackingHistoryStore((state: ITrackingHistoryState) => state?.trackingHistory)

    const promiseAll = useCallback(async (data: string) => {
        (await Promise.allSettled([
            trackPromise(GetTrackingHistoryByWayBillAction(data), 'tracking-by-waybill-details-area'),
            trackPromise(GetHistoryDetailByWayBillAction(data), 'tracking-by-way-bill-list-area')
        ]))
    }, [GetHistoryDetailByWayBillAction, GetTrackingHistoryByWayBillAction])

    const getTrackingData = useCallback(() => {
        if (data) {
            promiseAll(data)
        }
    }, [data, promiseAll])

    useEffect(() => {
        getTrackingData();
    }, [getTrackingData])

    const trackingHistoryColumn: ColumnsType<ITrackingHistory> = useMemo(() => [
        {
            title: 'Waybill No',
            dataIndex: 'waybillNo',
            key: 'waybillNo',
            width: 50,
            fixed: 'left',
        },
        {
            title: 'station',
            dataIndex: 'station',
            key: 'station',
            width: 40,
            fixed: 'left',
        },
        {
            title: 'event Text',
            dataIndex: 'eventText',
            key: 'eventText',
            width: 80,
        },
        {
            title: 'notes',
            dataIndex: 'notes',
            key: 'notes',
            width: 80,
        },
        {
            title: 'Scanned By',
            dataIndex: 'scannedBy',
            key: 'scannedBy',
            width: 80,
        },
        {
            title: 'scan Date',
            dataIndex: 'scanDate',
            key: 'scanDate',
            width: 80,
            render: (_, record) => convertDateFromMillis(record?.scanDate, DD_MM_YYYY_H_MM)
        },
        {
            title: 'comment',
            dataIndex: 'comment',
            key: 'comment',
            width: 150,
        },
    ], [])

    const onResetClicked = useCallback(() => {
        getTrackingData();
    }, [getTrackingData])

    return (
        <>
            {promiseInProgress && <LoadingComponent />}
            <Modal maskClosable={false} open={isOpen} onOk={closeModal} title={`Waybill Tracking History - ${data ?? ''}`} centered
                onCancel={closeModal} width={1500} cancelButtonProps={{
                    style: { display: 'none' }
                }}>
                <>
                    <div style={{ height: '25rem', overflowY: 'auto', overflowX: 'hidden', padding: '1rem' }}>
                        {children}
                        <TableComponent
                            scroll={{ x: 0, y: 0 }}
                            columns={trackingHistoryColumn}
                            isLoading={promiseInProgress}
                            data={trackingHistory}
                            onPaginationChange={() => { }}
                            onRefreshHandle={onResetClicked} />
                    </div>
                </>
            </Modal>
        </>
    )
}

export const TrackingHistoryPageComponent = () => {

    const { id } = useParams()
    const { promiseInProgress } = usePromiseTracker({ area: 'tracking-by-way-bill-list-area' })
    const GetTrackingHistoryByWayBillAction = useTrackingHistoryStore((state: ITrackingHistoryState) => state?.GetTrackingHistoryByWayBillAction)
    const GetHistoryDetailByWayBillAction = useTrackingHistoryStore((state: ITrackingHistoryState) => state?.GetHistoryDetailByWayBillAction)
    const trackingHistory: ITrackingHistory[] = useTrackingHistoryStore((state: ITrackingHistoryState) => state?.trackingHistory)
    const trackingHistoryDetail = useTrackingHistoryStore(state => state?.trackingHistoryDetail);

    const operationDetail = useTrackingHistoryStore((state: ITrackingHistoryState) => state?.rowDetail);

    const promiseAll = useCallback(async (id: string) => {
        (await Promise.allSettled([
            trackPromise(GetTrackingHistoryByWayBillAction(id), 'tracking-by-waybill-details-area'),
            trackPromise(GetHistoryDetailByWayBillAction(id), 'tracking-by-way-bill-list-area')
        ]))
    }, [GetHistoryDetailByWayBillAction, GetTrackingHistoryByWayBillAction])

    const getTrackingData = useCallback(() => {
        if (id) {
            promiseAll(id)
        }
    }, [id, promiseAll])

    useEffect(() => {
        getTrackingData();
    }, [getTrackingData])

    const trackingHistoryColumn: ColumnsType<ITrackingHistory> = useMemo(() => [
        {
            title: 'Waybill No',
            dataIndex: 'waybillNo',
            key: 'waybillNo',
            width: 50,
            fixed: 'left',
        },
        {
            title: 'station',
            dataIndex: 'station',
            key: 'station',
            width: 40,
            fixed: 'left',
        },
        {
            title: 'event Text',
            dataIndex: 'eventText',
            key: 'eventText',
            width: 80,
        },
        {
            title: 'notes',
            dataIndex: 'notes',
            key: 'notes',
            width: 80,
        },
        {
            title: 'Scanned By',
            dataIndex: 'scannedBy',
            key: 'scannedBy',
            width: 80,
        },
        {
            title: 'scan Date',
            dataIndex: 'scanDate',
            key: 'scanDate',
            width: 80,
            render: (_, record) => convertDateFromMillis(record?.scanDate, DD_MM_YYYY_H_MM)
        },
        {
            title: 'comment',
            dataIndex: 'comment',
            key: 'comment',
            width: 150,
        },
    ], [])

    const onResetClicked = useCallback(() => {
        getTrackingData();
    }, [getTrackingData]);



    return (
        <>
            <>
                <Row justify="space-between" align="top">
                    <Col>
                        <BackButtonComponent />
                    </Col>
                    <Col flex="1" style={{ textAlign: 'center' }}>
                        <Typography.Title level={4}>
                            Waybill Tracking History - {id}
                        </Typography.Title>
                        {trackingHistoryDetail?.isRto ? 
                            <Typography.Title level={5} style={{ marginTop: "0px", marginBottom: "0px", textAlign: "center" }}>
                                Original Waybill - {trackingHistoryDetail?.originalWaybillNoFromRto}
                            </Typography.Title> : 
                            null}
                    </Col>
                </Row>
                <div >
                    <TrackingHistoryDetailComponent />
                    <TableComponent
                        scroll={{ x: 0, y: 0 }}
                        columns={trackingHistoryColumn}
                        isLoading={promiseInProgress}
                        data={trackingHistory}
                        onPaginationChange={() => { }}
                        onRefreshHandle={onResetClicked} >
                        {
                            id === operationDetail?.waybillNo ? <Space size="large">
                                <Dropdown.Button
                                    overlay={
                                        <MenuList
                                            selectedRowKeys={[]}
                                            pageNumber={1}
                                            pageSize={10}
                                            setIsModalOpen={() => null}
                                            row={operationDetail}
                                            filteredData={{}}
                                        />
                                    }
                                >
                                    Action
                                </Dropdown.Button>
                            </Space> : null
                        }

                    </TableComponent>
                </div>
            </>

        </>
    )
}
